// extracted by mini-css-extract-plugin
export default {"sideBtn":"profilepopup_sideBtn__12JEe","popup":"profilepopup_popup__+NfdB","arrowTop":"profilepopup_arrowTop__p9kVv","popupWrapper":"profilepopup_popupWrapper__3yuIc"};